module.exports = __webpack_public_path__ + "static/assets/41c9882b9a5ef337aefe144a54c8fc7e.png";